<template>
  <div class="about-page" @scroll="bingsrcoll">
    <div class="hidden-sm-and-down">
      <div class="first-page" ref="firstPage">
        <!-- <img src="../assets/img/aboutme1_img.png" alt="关于我们">
        <div class="first-page-title">
          <div>德卡科技</div>
          <div>让生活更便捷</div>
        </div> -->
        <div class="about-main-title">
          <img v-if="aboutData.children[0].requestType.indexOf('image') > -1" :src="aboutData.children[0].requestPath"
            alt="aboutData.dictLabel" style="height:100%;">
          <div v-else style="width: 100%;height:100%;">
            <video class="about-video" id="aboutvideo" width="100%" height="100%" name="media" muted loop>
              <source :src="aboutData.children[0].requestPath" type="video/mp4">
              <span v-if="this.isEn != '1'">您的浏览器不支持 video 标签。</span>
              <span v-if="this.isEn == '1'">The browser does not support video tags。</span>
            </video>
          </div>
          <div class="first-page-title">
            <div>{{ aboutData.children[0].title }}</div>
            <div class="title-line"></div>
            <div v-if="videoAll && videoAll[0] && videoAll[0].title == '观看全部视频'" @click="openVideoShow"
              style="text-align: left;font-size: 22px;cursor: pointer;">
              <i class="el-icon-video-play"
                style="font-weight: inherit;font-size: 30px;vertical-align: text-top;margin-right: 2px;"></i>
              <span v-if="this.isEn != '1'">观看全部视频</span>
              <span v-if="this.isEn == '1'">Watch all videos</span>
            </div>
            <pre v-else class="first-page-titledesc">{{ aboutData.children[0].content }}</pre>
          </div>
        </div>
      </div>
      <div :class="['about-menu', window_height < (scroll_Value - 65) ? 'fix-menu' : '']">
        <div @click.prevent="custormAnchor('miao1')" href="#miao1">
          <span v-if="isEn == '0'" :class="[custormAnchor_nav == 'miao1' ? 'menu-active' : '']">公司介绍 </span>
          <span v-if="isEn == '1'" :class="[custormAnchor_nav == 'miao1' ? 'menu-active' : '']">Company introduction </span>
        </div>
        <div @click.prevent="custormAnchor('miao2')" href="#miao2">
          <span v-if="isEn == '0'" :class="[custormAnchor_nav == 'miao2' ? 'menu-active' : '']">发展历程</span>
          <span v-if="isEn == '1'" :class="[custormAnchor_nav == 'miao2' ? 'menu-active' : '']">History</span>
        </div>
        <div @click.prevent="custormAnchor('miao3')" href="#miao3">
          <span v-if="isEn == '0'" :class="[custormAnchor_nav == 'miao3' ? 'menu-active' : '']">企业文化</span>
          <span v-if="isEn == '1'" :class="[custormAnchor_nav == 'miao3' ? 'menu-active' : '']">Corporate culture</span>
        </div>
        <!-- <div @click.prevent="custormAnchor('miao4')" href="#miao3">
          <span :class="[custormAnchor_nav=='miao4'?'menu-active':'']">知识产权</span>
        </div> -->
        <div @click.prevent="custormAnchor('miao5')" href="#miao5">
          <span v-if="isEn == '0'" :class="[custormAnchor_nav == 'miao5' ? 'menu-active' : '']">资质荣誉</span>
          <span v-if="isEn == '1'" :class="[custormAnchor_nav == 'miao5' ? 'menu-active' : '']">Qualification and honor</span>
        </div>
      </div>
      <div class="about-content row">
        <div id="miao1" class="row col-md-90">
          <div class="col-md-4">
            <div  v-if="isEn == '0'" class="about-content-title">
              <div>公司介绍</div>
             <!-- <div class="about-content-secondtitle">INTRODUCTION</div>-->
            </div>
            <div  v-if="isEn == '1'" class="about-content-title">
              <div>Company introduction</div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="text-indent">
              <pre
                class="afterService-content">{{ CompanyData.companyInfo && CompanyData.companyInfo.companyProfile }}</pre>
              <!-- <div>
                <p>
                  深圳市德卡科技股份有限公司创立于2005年，公司是专业的身份识别和移动支付产品供应商，专门从事IC卡读写机、身份识别技术、支付终端、信息安全产品、物联网设备等产品的研发、生产、销售和服务，是国家认证的高新技术企业。
                </p>
                <p>
                  德卡科技始终专注于技术研发和创新，产品拥有自主知识产权。德卡致力于产品的易用和易开发的推动，开创了多项行业应用首创的技术专利。德卡累计申请专利100多项，其中发明专利5项、实用新型10项、外观专利45项、软件产品登记证书及证明涵19项、软件著作权证书40项，推出全球首款免驱动USB接口IC卡读写器，是“具有USB接口的IC卡读卡器”专利的国内持有人。
                </p>
                <p>
                  德卡拥有COS（芯片操作系统）、硬件设计、安全体系、应用软件开发、系统集成全线的开发技术。公司75%的员工从事研发、开发和技术服务，公司15%的销售额作为研发投入。除了深圳总部的研发中心外，在北京、西安分公司分别组建了技术研发中心，研发团队总人数占总职工人数的50%以上。德卡公司集聚力量为公司提供强有力的技术保障。
                </p>
                <p>
                  德卡科技创立的“D & C”读写器品牌是中国IC卡读写器行业的领先品牌，产品主要服务于社会保障、卫生医疗、交通运输、金融、教育等领域。目前德卡在全国17个中心城市建有销售服务机构，售后服务网络遍布全国30多个地市，为每一位客户提供便捷的售后服务支撑。
                </p>
                <p>
                  我们将继续以“树民族科技，创世界品牌”为坐标，不断的创新突破，超越自我，让更多、更好、更专业的产品走进千家万户，实现自己的价值。
                </p>
              </div> -->
            </div>
          </div>
          <div class="col-md-12 row middle2" style="padding:0px;margin-top:50px;">
            <div class="zidingyi-col4" v-for="(item, index) in companyProfileData.children" :key="'path1' + index">
              <img :src="item.requestPath" :alt="item.title" style="width:100%;" />
            </div>
          </div>
        </div>
        <div id="miao2" class="row col-md-90">
          <div :style="{ 'display': isSafari == true ? 'block' : 'none' }" style="width:100%;">
            <div class="col-md-4" style="float:left;">
              <div v-if="isEn == '0'" class="about-content-title">
                <div>发展历程</div>
               <!-- <div class="about-content-secondtitle">DEVELOPING</div>-->
              </div>
              <div v-if="isEn == '1'" class="about-content-title">
                <div>History</div>
              </div>
            </div>
            <div class="col-md-8" style="float:left;">
              <div id="steps1"></div>
            </div>
          </div>

          <div :style="{ 'display': isSafari == false ? 'block' : 'none' }" style="width:100%;">
            <div class="col-md-4" style="float:left;">
              <div class="about-content-title">
                <div>发展历程</div>
               <!-- <div class="about-content-secondtitle">DEVELOPING</div>-->
              </div>
            </div>
            <div class="col-md-8" style="float:left;">
              <div v-for="(item, index) in StepList" :key="index">
                <div class="about-content-secondTitle">{{ item.title }}</div>
                <pre class="about-content-secondTitleDesc" v-html="item.description"></pre>
              </div>

            </div>
          </div>
        </div>

        <div id="miao3">
          <!-- <img src="../assets/img/aboutme6_img.jpg" alt="企业文化" style="width:100%;"> -->
          <img :src="cultureData.children[0].requestPath" alt="企业文化" style="width:100%;">
          <!-- <div class="row auto-center">
                <div class="col-md-4" style="margin-top: 42px;">
                    <div class="about-content-title qiyi-title">
                        <div>企业文化</div>
                        <div class="about-content-secondtitle">CULTURE</div>
                    </div>
                </div>
                <div class="col-md-8 aboutuse4-content">
                    <div class="about-list">
                      <div class="label-left">企业责任</div>
                      <div class="label-right">
                          <div>树民族科技</div>
                          <div>创世界品牌</div>
                      </div>
                    </div>
                    <div class="about-list">
                      <div class="label-left">经营理念</div>
                      <div class="label-right">
                          <div>专业   专注   创新</div>
                      </div>
                    </div>
                    <div class="about-list">
                      <div class="label-left">企业文化</div>
                      <div class="label-right">
                          <div>以观念创新为先导</div>
                          <div>以战略创新为基础</div>
                          <div>以组织创新为保障</div>
                          <div>以技术创新为手段</div>
                          <div>以市场创新为目标</div>
                      </div>
                    </div>
                    <div class="about-list">
                      <div class="label-left" style="margin-right: 50px;">我们的追求</div>
                      <div class="label-right">
                          <div>员工的普遍认同和主动参与</div>
                          <div>与合作伙伴共同成功</div>
                      </div>
                    </div>
                    <div class="about-list">
                      <div class="label-left">发展策略</div>
                      <div class="label-right">
                          <div>创新引领发展</div>
                          <div>服务赢得市场</div>
                      </div>
                    </div>
                </div>
              </div> -->
        </div>
        <!-- <div id="miao4" class="row col-md-12">
            知识产权
          </div> -->
        <div id="miao5" class="row col-md-12" v-if="qualificationData.children.length > 0">
          <div class="row col-md-90">
            <div class="col-md-4">
              <div v-if="isEn == '0'" class="about-content-title">
                <div>资质荣誉</div>
                <!--<div class="about-content-secondtitle">HONOR</div>-->
              </div>
              <div v-if="isEn == '1'" class="about-content-title">
                <div>Qualification and honor</div>
              </div>
            </div>
            <div class="col-md-8 miao5 row">
              <div class="col-md-3" v-for="(item, index) in qualificationData.children" :key="'path2' + index">
                <div class="img-content" @click="openImgShow(item.requestPath)">
                  <img :src="item.requestPath" :alt="item.title">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <home-foot></home-foot>
    </div>


    <div class="visible-sm-and-down">
      <div class="mobile-banner">
        <img src="../assets/mobile/aboutme01_img.jpg" alt="">
        <!-- <div class="mobile-banner-title">
          <div>关于我们</div>
          <div>ABOUT ME</div>
        </div> -->
      </div>
      <div class="mobile-content">
        <div class="mobile-content-title">公司介绍</div>
        <pre
          class="afterService-content mobile-content-text">{{ CompanyData.companyInfo && CompanyData.companyInfo.companyProfile }}</pre>
        <!-- <div class="mobile-content-text" style="margin-top:20px;margin-bottom:0px;">
          <p>深圳市德卡科技股份有限公司创立于2005年，公司是专业的身份识别和移动支付产品供应商，专门从事IC卡读写机、身份识别技术、支付终端、信息安全产品、物联网设备等产品的研发、生产、销售和服务，是国家认证的高新技术企业。</p>
          <p>德卡科技始终专注于技术研发和创新，产品拥有自主知识产权。德卡致力于产品的易用和易开发的推动，开创了多项行业应用首创的技术专利。德卡累计申请专利100多项，其中发明专利5项、实用新型10项、外观专利45项、软件产品登记证书及证明涵19项、软件著作权证书40项，推出全球首款免驱动USB接口IC卡读写器，是“具有USB接口的IC卡读卡器”专利的国内持有人。</p>
          <p>德卡拥有COS（芯片操作系统）、硬件设计、安全体系、应用软件开发、系统集成全线的开发技术。公司75%的员工从事研发、开发和技术服务，公司15%的销售额作为研发投入。除了深圳总部的研发中心外，在北京、西安分公司分别组建了技术研发中心，研发团队总人数占总职工人数的50%以上。德卡公司集聚力量为公司提供强有力的技术保障。</p>
          <p>德卡科技创立的“D & C”读写器品牌是中国IC卡读写器行业的领先品牌，产品主要服务于社会保障、卫生医疗、交通运输、金融、教育等领域。目前德卡在全国17个中心城市建有销售服务机构，售后服务网络遍布全国30多个地市，为每一位客户提供便捷的售后服务支撑。</p>
          <p>我们将继续以“树民族科技，创世界品牌”为坐标，不断的创新突破，超越自我，让更多、更好、更专业的产品走进千家万户，实现自己的价值。</p>
        </div> -->
        <!-- <img src="../assets/img/aboutme3_img.jpg"/>
        <img src="../assets/img/aboutme4_img.jpg"/> -->
        <img v-for="(item, index) in companyProfileData.children" :key="'path' + index" :src="item.requestPath"
          :alt="item.title" style="width:100%;margin-top:32px;" />
        <div class="mobile-content-title">发展历程</div>
        <div v-for="(item, index) in StepList" :key="'list' + index">
          <div class="mobile-content-titlesecond">{{ item.title }}</div>
          <pre class="mobile-develop" v-html="item.description"></pre>
        </div>
        <div class="mobile-content-title">企业文化</div>
        <!-- <img class="mobile-bottom-img" src="../assets/mobile/aboutme5_img.jpg"> -->
        <img class="mobile-bottom-img" :src="cultureData.children[0].requestPath">
        <!-- <div class="corporateCulture">
          <div class="corporateCulture-row clearfix">
            <div class="corporateCulture-left">企业责任</div>
            <div class="corporateCulture-right">
              <div class="corporateCulture-right-desc">树民族科技</div>
              <div class="corporateCulture-right-desc">创世界品牌</div>
            </div>
          </div>
          <div class="corporateCulture-row clearfix">
            <div class="corporateCulture-left">经营理念</div>
            <div class="corporateCulture-right">
              <div class="corporateCulture-right-desc">专业 专注 创新</div>
            </div>
          </div>
           <div class="corporateCulture-row clearfix">
            <div class="corporateCulture-left">企业文化</div>
            <div class="corporateCulture-right">
              <div class="corporateCulture-right-desc">以观念创新为先导</div>
              <div class="corporateCulture-right-desc">以战略创新为基础</div>
              <div class="corporateCulture-right-desc">以组织创新为保障</div>
              <div class="corporateCulture-right-desc">以技术创新为手段</div>
              <div class="corporateCulture-right-desc">以市场创新为目标</div>
            </div>
          </div>
           <div class="corporateCulture-row clearfix">
            <div class="corporateCulture-left">我们的追求</div>
            <div class="corporateCulture-right">
              <div class="corporateCulture-right-desc">员工的普遍认同和主动参与</div>
              <div class="corporateCulture-right-desc">与合作伙伴共同成功</div>
            </div>
          </div>
           <div class="corporateCulture-row clearfix">
            <div class="corporateCulture-left">发展策略</div>
            <div class="corporateCulture-right">
              <div class="corporateCulture-right-desc">创新引领发展</div>
              <div class="corporateCulture-right-desc">服务赢得市场 </div>
            </div>
          </div>
        </div> -->
        <div class="mobile-content-title">资质荣誉</div>
        <div class="mobile-certificate">
          <div class="mobile-certificate-lis" v-for="(item, index) in qualificationData.children" :key="'cert' + index">
            <img :src="item.requestPath" :alt="item.title" />
          </div>
        </div>
      </div>
      <home-foot></home-foot>
    </div>
    <videoCommon ref="videoProp" v-if="videoAll[0]" :videoTitle="videoAll[0].title" :videoUrl="videoAll[0].requestPath">
    </videoCommon>
    <imgScaleBig ref="imgBig" :imgUrl="imgUrl"></imgScaleBig>

  </div>
</template>


<script>
import HomeFoot from "@/components/HomeFoot";
import Bus from '../Bus.js';
//  引入step 组件
import "@/assets/js/steps.js";
import '@/assets/css/steps.css';
import videoCommon from "@/components/videoCommon";
import imgScaleBig from "@/components/imgScaleBig";

export default {
  name: "about",
  components: {
    HomeFoot,
    videoCommon,
    imgScaleBig
  },
  data() {
    return {
      window_height: 900,
      firstPage_height: "",
      scroll_Value: "0",
      page_height: "",
      custormAnchor_nav: "miao1",
      window_width: document.body.clientWidth,
      videoTitle: "关于我们",//
      videoUrl: "/static/link/video/aboutUseALL.mp4",
      imgUrl: '',
      isSafari: false,
      StepList: [
        { title: "2019", description: "<p style='line-height: 26px;'> 发布人脸识别支付终端产品线F10、F11、Z90N、M300J、P18Q </p><p  style='line-height: 26px;'> 2019年“互联网+交通运输”优秀案例奖 </p><p style='line-height: 26px;'> 与支付宝签订“互联网公交”战略合作协议 </p> ", },
        { title: "2018", description: "<p style='line-height: 26px;'> 升级主流IC卡读写器产品、终端产品支持二维码配置升级T10-F、P30、Z90-S、P18-L2，发布智慧医疗终端M300 </p><p style='line-height: 26px;'> 获得西安、成都、拉萨、海口等全国三十余个城市公交终端二维码支付升级项目</p><p style='line-height: 26px;'>2018中国银联商务车载终端入围厂商</p><p style='line-height: 26px;'>2018年全国医疗行业领域读写器市场占有率第一</p>" },
        { title: "2017", description: "<p style='line-height: 26px;'>发布银联云闪付终端产品线P18-A7S、T80-A2、T80-L2，发布人社服务终端服务解决方案M200、DC-KK1000D制卡领卡终端；</p><p style='line-height: 26px;'>2017年度在全国银联云闪付领域POS机占有率排名第一；</p><p style='line-height: 26px;'>2017年度在全国医疗行业领域读写器占有率排名第一；</p><p style='line-height: 26px;'>参加人社部信息中心“全国社会保障卡跨省应用和第三代社会保障卡课题”建设，并获得表彰；</p>" },
        { title: "2015 - 2016", description: "<p style='line-height: 26px;'>发布第二代USBKEY产品X2，并推出个人互联网终端系列X1、X6、X8支持国密算法；</p><p>发布第一代支付终端类产品P10、P12、P16、P18，推出远距离识别物联网产品线W5、W8；</p><p style='line-height: 26px;'>支持国密算法并获得国家商用密码产品销售许可证；</p><p style='line-height: 26px;'>成立西安、成都、北京研发中心，提供一卡通领域应用开发支持；</p><p style='line-height: 26px;'>产品形成行业卡读写机具、互联网支付终端、物联网产品线及卡应用及信息安全组件为主线的软硬件产品系列；</p><p style='line-height: 26px;'>中国银联迷你付终端C款、“金蟾”指定研发生产企业；</p><p style='line-height: 26px;'>成功入围银联商务非接支付终端供应商；</p><p style='line-height: 26px;'>参加住建部多项IC卡行业应用标准建设；</p>" },
        { title: "2010 - 2014", description: "<p style='line-height: 26px;'>发布第二代读写器产品发布D6、D8，发布多功能读写器Z9、Z12、Z16，发布信息安全产品（USBKey）HC1008；</p><p style='line-height: 26px;'>发布二代证多功能读写器T10，支持磁条、接触、非接触、二代证；</p><p style='line-height: 26px;'>首家推出具有USB接口的IC卡读写器，并获得该专利；</p><p style='line-height: 26px;'>全面提升管理规范体系，通过生产许可证、ISO9000等一系列认证；</p><p style='line-height: 26px;'>多款产品获得社保部认证资格，社保卡市场份额开始领先，成为IC卡读写器厂商领跑者；</p><p style='line-height: 26px;'>首款产品通过银行检测中心检测，产品涉入金融IC卡应用领域；</p><p style='line-height: 26px;'>获得国家级高新技术企业认定；</p>" },
        { title: "1999 - 2004", description: "<p style='line-height: 26px;'>国内首家专业从事IC卡读写器研发生产的企业</p><p style='line-height: 26px;'>发布第一代读写器RD600、RD800、RD900</p>" },
      ],
      videoAll: "",
      CompanyData: "",
      aboutData: {},  //服务平台
      qualificationData: {},//资深荣誉
      cultureData: {}, //企业文化
      companyProfileData:{}, //公司介绍
      isEn:"0",
    };
  },
  created() {
    this.$picData.map((item) => {
      if (item.dictCode == 106) {
        this.aboutData = item
      } else if (item.dictCode == 111) {
        //资深荣誉
        this.qualificationData = item
      } else if (item.dictCode == 112) {
        //企业文化
        this.cultureData = item
      }else if (item.dictCode == 110) {
        //公司介绍
        this.companyProfileData = item
      }
    })
    setTimeout(function () {
      this.window_height = $(".first-page").height();
    }, 1000)
    this.isEn = ('1' ==sessionStorage.getItem("isEn")? sessionStorage.getItem("isEn") : '0')

  },
  mounted() {
    // this.firstPage_height = this.$refs.firstPage.offsetHeight - 70;
    // this.page_height =
    //   $(".about-content").height() +
    //   $(".first-page").height() -
    //   document.body.offsetHeight;
    //  获取发展历程
    axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/developProgress/list?isEn=`+this.isEn, {}
    ).then((response) => {
      var res = response.data
      if (res.code == 200) {
        let step = []
        res.data.forEach(element => {
          step.push({
            title: element.endTime ? element.startTime + " - " + element.endTime : element.startTime,
            description: element.content,
          })
        });
        var steps1 = steps({
          el: "#steps1",
          data: step,
          direction: "vertical",
          // iconType: "custom",  // 自定义
          iconType: "bullets",   //圆
          dataOrder: ["title", "line", "description"],
          dataWidth: ["0 0 100px", "none", "auto"],
          active: step.length,
        });
        this.StepList = step;
      }
    }).catch(res => {

    })

    axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/company/info?isEn=`+this.isEn,).then(response => {
      var res = response.data
      if (res.code === 200) {
        this.CompanyData = res.data
      } else {
        this.$message.error(res.msg ? res.msg : '请求有误，请稍后重试')
      }
    }).catch(error => {
      this.$message.error(res.msg ? res.msg : '请求有误，请稍后重试')
    })

    // 锚点链接过来的, 得的的
    let mao = this.$route.params.mao;
    mao ?
      this.about_roll_down(mao) : "";

    var videoid = document.getElementById('aboutvideo');
    if (videoid) {
      var windowWidth = $(window).width();
      if (windowWidth < 991) {
        videoid.autoplay = false;
      } else if (windowWidth >= 991) {
        videoid.autoplay = true;
      }
    }



    // 获取浏览器内核和版本号
    var neihe = this.getBrowser("n"); // 所获得的就是浏览器所用内核。
    var banben = this.getBrowser("v");// 所获得的就是浏览器的版本号。
    var browser = this.getBrowser();
    if (!neihe || (neihe == "safari" && banben < 10)) {
      //  当使用safari浏览器，并且是低版本
      //  这里面的东西不支持 。 不要打豆豆
      this.isSafari = false;
    } else {
      this.isSafari = true;
    }
    this.videoAll = this.aboutData.children.filter(t => t.title == "观看全部视频");
  },
  computed: {
    left_content_class() {
      if (this.scroll_Value < this.firstPage_height) {
        let obj = "100px";
        return obj;
      } else if (this.scroll_Value > this.firstPage_height) {
        let obj = this.scroll_Value - this.firstPage_height + 100 + "px";
        return obj;
      }
    }
  },
  methods: {
    getBrowser(n) {
      var ua = navigator.userAgent.toLowerCase(),
        s,
        name = '',
        ver = 0;
      //探测浏览器
      (s = ua.match(/msie ([\d.]+)/)) ? _set("ie", _toFixedVersion(s[1])) :
        (s = ua.match(/firefox\/([\d.]+)/)) ? _set("firefox", _toFixedVersion(s[1])) :
          (s = ua.match(/chrome\/([\d.]+)/)) ? _set("chrome", _toFixedVersion(s[1])) :
            (s = ua.match(/opera.([\d.]+)/)) ? _set("opera", _toFixedVersion(s[1])) :
              (s = ua.match(/version\/([\d.]+).*safari/)) ? _set("safari", _toFixedVersion(s[1])) : 0;

      function _toFixedVersion(ver, floatLength) {
        ver = ('' + ver).replace(/_/g, '.');
        floatLength = floatLength || 1;
        ver = String(ver).split('.');
        ver = ver[0] + '.' + (ver[1] || '0');
        ver = Number(ver).toFixed(floatLength);
        return ver;
      }
      function _set(bname, bver) {
        name = bname;
        ver = bver;
      }
      return (n == 'n' ? name : (n == 'v' ? ver : name + ver));
    },
    openVideoShow() {
      this.$refs.videoProp.openVideoShow();
    },
    closeVideoShow() {
      this.$refs.videoProp.closevideoShow();
    },
    openImgShow(url) {
      this.imgUrl = url;
      this.$refs.imgBig.openImgShow();
    },
    closeImgShow() {
      this.$refs.imgBig.closeImgShow();
    },
    custormAnchor(anchorName) {
      // 找到锚点
      let anchorElement = document.getElementById(anchorName);
      this.custormAnchor_nav = anchorName;
      // 如果对应id的锚点存在，就跳转到锚点
      if (anchorElement) {
        let scroll_value = document.getElementById(anchorName).offsetTop - 129
        $('.about-page').animate({ scrollTop: (Number(scroll_value)) }, 600);
      }
    },
    bingsrcoll(e) {
      this.scroll_Value = e.srcElement.scrollTop;
      let miao1 = document.getElementById("miao1").offsetTop
      let miao2 = document.getElementById("miao2").offsetTop
      let miao3 = document.getElementById("miao3").offsetTop
      let miao5 = document.getElementById("miao5").offsetTop
      if (this.scroll_Value >= (miao5 - 130)) {
        this.custormAnchor_nav = "miao5";
      } else if (this.scroll_Value >= (miao3 - 130)) {
        this.custormAnchor_nav = "miao3";
      } else if (this.scroll_Value >= (miao2 - 130)) {
        this.custormAnchor_nav = "miao2";
      } else {
        this.custormAnchor_nav = "miao1";
      }
    },
    about_roll_down(mao) {
      let height = $(window).height();
      let scroll_value = $("#" + mao).offset().top;
      $('.about-page').animate({ scrollTop: (Number(scroll_value) - 130) }, 600);
    },
    change_window_height() {
      // this.window_height=$(".first-page").height();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.about-main-title {
  position: relative;
  height: 100%;
  background: ('../assets/img/news1_img.jpg');
  overflow: hidden;
}

.about-video {
  height: -webkit-fill-available;
  width: -webkit-fill-available;
  object-fit: cover;
}

.about-videoimg {
  width: 100%;
  height: 100%;
}

.about-main-title-text {
  position: absolute;
  bottom: 130px;
  left: 15%;
  color: #fff;
}

.about-main-title-text1 {
  font-size: 20px;
}

.about-main-title-text2 {
  font-size: 32px;
}

.about-main-product-roll {
  position: absolute;
  bottom: 32px;
  left: 50%;
  color: #fff;
  cursor: pointer;
  font-size: 24px;
  margin-left: -12px;
}

.about-page {
  // margin-top: 60px;
  overflow: auto;
  height: 100%;
  width: 100%;
}

/* .about-content{
    margin-bottom: 10px;
} */
/* .about-content .left-content{
    position: relative;
    height: 500px;
}
.left-content>div{
    position: absolute;
    right: 20px;
    padding: 10px;
    line-height: 30px;
    border: 1px solid #ddd;
    width: 150px;
    cursor: pointer;
}
.left-content>div a{
    display: inline-block;
    color: #333;
} */
.about-content-secondTitle {
  margin-top: 20px;
  font-size: 20px;
  color: #202020;
  font-weight: 600;
  line-height: 20px;
}

.about-content-secondTitleDesc {
  margin-top: 20px;
  font-size: 14px;
  line-height: 24px;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.first-page {
  /* height: 800px; */
  /* background: url("../assets/img/aboutme1_img.png") no-repeat; */
  /* background-size: 100% 100%; */
  position: relative;
}

.first-page-title {
  color: #fff;
  position: absolute;
  top: 40%;
  left: 15%;
  margin-top: -22px;
}

.first-page-title>div:nth-child(1) {
  font-size: 48px;
  font-weight: 600;
}

.first-page-title .title-line {
  width: 68px;
  height: 3px;
  background: #fff;
  border-radius: 1px;
  margin-top: 12px;
  margin-bottom: 15px;
  margin-left: 2px;
}

.first-page-title>div:nth-child(3) {
  font-size: 22px;
  cursor: pointer;
}

// .first-page-title > div:nth-child(3):hover {
//   font-size: 23px;
// }
.middle2>div:nth-child(2) {
  margin: 0 2%;
}

.about-menu {
  height: 60px;
  line-height: 60px;
  padding-left: 50px;
  border-bottom: 1px solid #E3E3E3;
}

.about-menu>div {
  display: inline-block;
  margin-right: 50px;
}

.about-menu>div>span {
  cursor: pointer;
  padding: 0;
  height: 100%;
  display: inline-block;
  color: #868686;
}

.about-content {
  font-size: 14px;
  color: #2C2C2C;
}

.about-content>div {
  min-width: 900px;
  /* max-width: 1600px; */
  margin: 0 auto;
  /* margin-top: 100px; */
  padding-top: 100px;
  // min-height: 800px;
}

.about-content-title {
  font-weight: 600;
  font-size: 32px;
  color: #2C2C2C;
  line-height: 32px;
}

.about-content-title .about-content-secondtitle {
  font-size: 16px;
  color: #C2C2C2;
  font-weight: 400;
}

/* miao2 */
#miao2 .Development>div {
  display: inline-block;
  height: 24px;
  line-height: 24px;
}

#miao2 .Development .has-line {
  border-right: 1px solid #ddd;
  height: 24px;
  width: 5px;
}

#miao2 .Development .has-content {
  width: 300px;
}

.first-page-titledesc {
  font-size: 22px;
  color: #fff;
  font-weight: normal;
}

/* miao3 */
#miao3 {
  // margin-top: 250px;
  /* background: url("../assets/img/aboutme6_img.png") no-repeat; */
  /* background-size: 100% 100%; */
  width: 100%;
  /* height: 600px; */
  min-height: 700px;
  position: relative;
}

#miao3 .about-content-title {
  color: #fff;
}

#miao3 .about-content-title .about-content-secondtitle {
  color: #fff;
}

#miao3 .auto-center {
  position: absolute;
  left: 15%;
  width: 70%;
  top: 25%;
}

#miao3 .wenhua-title {
  color: #fff;
  font-size: 34px;
  margin-top: 100px;
  margin-left: 20px;
}

#miao3 .miao3 {
  position: relative;
}

.miao3 .wenhua {
  position: absolute;
  top: -6rem;
  // right: 4rem;
}


/* miao4 */
.aboutuse4-content {
  margin-top: 42px;
  color: #fff;
  // padding-left: 56px;
}

.about-list {
  margin-top: 20px;
}

.about-list .label-left {
  vertical-align: top;
  font-size: 20px;
  color: #4ACBF4;
  margin-right: 70px;
  display: inline-block;
}

.about-list .label-right {
  display: inline-block;
  font-size: 16px;
  line-height: 32px;
}

/* miao5 */
#miao5 {
  margin-bottom: 100px;
}

#miao5>div {
  margin: 0 auto;
}

#miao5 .miao5>div {
  display: inline-block;
  width: 20%;
  padding: 10px;
  margin-bottom: 20px;
}

#miao5 .miao5>div .img-content {
  width: 90%;
  height: 100%;
  cursor: pointer;
}

#miao5 .miao5>div img {
  width: 100%;
}

#miao5 .step-description {
  line-height: 26px;
}

/*  自定义步骤条  */
body .custom-class .steps-vertical .step-line {
  top: 19px;
}

.step-icon-custom-box {
  width: 40px;
  height: 40px;
}

.step-icon-custom {
  margin-top: -2px;
  font-size: 26px;
}




/* 笔记本适应性 */
@media only screen and (max-width:1800px) {
  #miao3 .auto-center {
    position: absolute;
    left: 15%;
    width: 80%;
    top: 20%;
  }
}

@media only screen and (max-width:1600px) {
  #miao3 .auto-center {
    position: absolute;
    left: 15%;
    width: 80%;
    top: 24%;
  }
}

/* 笔记本适应性 */
@media only screen and (max-width:1500px) {
  #miao3 .auto-center {
    position: absolute;
    left: 15%;
    width: 85%;
    top: 22%;
  }

}

/* 笔记本适应性 */
@media only screen and (max-width:1400px) {
  #miao3 .auto-center {
    position: absolute;
    left: 15%;
    width: 85%;
    top: 17%;
  }

  .qiyi-title {
    font-size: 30px;
  }

  .about-list {
    margin-top: 18px;
  }

  .about-list:first-child {
    margin-top: 5px;
  }

  .about-list:first-child {
    margin-top: 5px;
  }

  .about-list .label-left {
    font-size: 19px;
  }

  .about-list .label-right {
    font-size: 15px;
    line-height: 28px;
  }
}

/* 中屏以上  宽度修正 */
@media only screen and (max-width:1200px) {
  #miao3 .auto-center {
    position: absolute;
    left: 15%;
    top: 15%;
  }

  .qiyi-title {
    font-size: 28px;
  }

  .about-list {
    margin-top: 16px;
  }

  .about-list:first-child {
    margin-top: 5px;
  }

  .about-list .label-left {
    font-size: 18px;
  }

  .about-list .label-right {
    font-size: 14px;
    line-height: 26px;
  }
}

/* 中屏以上  宽度修正 */
@media only screen and (max-width:1100px) {
  #miao3 .auto-center {
    position: absolute;
    left: 15%;
    top: 10%;
  }
}

@media only screen and (max-width:991px) {

  /* 移动端 */
  .mobile-content {
    img {
      width: 100%;
    }

    .mobile-bottom-img {
      margin-top: 40px;
    }
  }

  .mobile-content .mobile-bottom-img {
    margin-top: 30px;
  }

  .mobile-certificate {
    width: 100%;
    overflow: hidden;
    margin-top: 25px;
  }

  .mobile-certificate-lis {
    width: 25%;
    // padding-right: 16px;
    margin-bottom: 20px;
    display: inline-block;

    &:nth-of-type(1n) {
      padding-right: 12px;
    }

    &:nth-of-type(2n) {
      padding-left: 4px;
      padding-right: 8px;
    }

    &:nth-of-type(3n) {
      padding-left: 8px;
      padding-right: 4px;
    }

    &:nth-of-type(4n) {
      padding-left: 12px;
      padding-right: 0px;
    }

    img {
      width: 100%;
    }
  }

  .corporateCulture {
    margin-top: 20px;
  }

  .corporateCulture-row {
    width: 100%;
    margin: 0 auto 20px;
  }

  .corporateCulture-left {
    float: left;
    width: 36%;
    font-size: 18px;
    color: #3BBDE7;
    font-weight: 600;
  }

  .corporateCulture-right {
    float: left;
    width: 64%;
  }

  .corporateCulture-right-desc {
    color: #202020;
    font-size: 14px;
    line-height: 28px;
  }

  .mobile-develop,
  .mobile-content-text p {
    color: #202020;
    font-size: 14px;
    line-height: 28px;
  }

  .mobile-content-titlesecond {
    margin-top: 20px;
    font-size: 20px;
    color: #202020;
    font-weight: 600;
    line-height: 20px;
  }

  .mobile-content-title {
    margin-top: 48px;
    font-size: 22px;
  }
}

.afterService-content {
  margin-top: 20px;
  font-size: 14px;
  line-height: 30px;
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}
</style>




// WEBPACK FOOTER //
// src/views/about.vue